import React from 'react';
import { getAbsenteeism } from '../../services/timesheetService';
import PresetReportPage from './components/PresetReportPage';

// AKM POC §5.15 / §7 — Devam Paneli'nden panel süzgeçleriyle açılabilir; ortak süzgeç seti, TA ekip kapsamı ve sunucu
// tarafı Excel / PDF dışa aktarma ortak gövdede (PresetReportPage).
export default function AbsenteeismPage() {
  return <PresetReportPage fetchFn={getAbsenteeism} titleKey="pdks.absenteeismTitle" exportUrl="/v1/ta/reports/absenteeism/export" />;
}
